module.exports = __webpack_public_path__ + "static/media/block-6-ipswich.c72b8edc.png";